import React from 'react'
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Match: all' },
  { id: 'true', name: 'Matched' },
  { id: 'false', name: 'Not matched' },
]

export default function MatchStatusSelect(props) {
  return <Select {...props} options={STATUSES} />
}
